import { render } from "./ProductDetailsDialog.vue?vue&type=template&id=e028bf02&scoped=true&ts=true"
import script from "./ProductDetailsDialog.vue?vue&type=script&lang=ts"
export * from "./ProductDetailsDialog.vue?vue&type=script&lang=ts"

import "./ProductDetailsDialog.vue?vue&type=style&index=0&id=e028bf02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e028bf02"]])

export default __exports__